import type { CandidateVacancy } from '../types';

type CandidateVacancyActivity = NonNullable<
  CandidateVacancy['vacancyActivities']
>[number];

export function mockCandidateVacancyActivity(
  overrides: Partial<CandidateVacancyActivity> = {}
): CandidateVacancyActivity {
  return {
    id: 1,
    vacancyId: 1,
    activeFrom: '2026-07-01T00:00:00.000Z',
    activeTo: '2026-08-01T00:00:00.000Z',
    ...overrides,
  };
}
